/**	
	* Template Name: Be-Hero
	* Version: 1.0	
	* Template Scripts
	* Author: MarkUps
	* Author URI: http://www.markups.io/

	Custom JS
	
	1. MAIN SLIDER
	2. VIDEO POPUP
	3. TESTIMONIALS (SLICK SLIDER)
	4. SCROLL TOP BUTTON
	5. CLIENTS SLIDEER ( SLICK SLIDER )
	6. PORTFOLIO GALLERY
	7. PORTFOLIO POPUP VIEW ( IMAGE LIGHTBOX )
	
	
**/



$(function(){

	var menuItem = $('#menuSelect').val();
	// menu selected on load
	switchNavMenu(menuItem);
});

function initializeAllComponents(){
	/* ----------------------------------------------------------- */
	/*  1. MAIN SLIDER
	/* ----------------------------------------------------------- */

	$('.mu-slide').not('.slick-initialized').slick({
		arrows: true,
		dots: false,
		infinite: true,
		speed: 500,
		autoplay: true,
		cssEase: 'linear'
	});

	
	/* ----------------------------------------------------------- */
	/*  2. VIDEO POPUP
	/* ----------------------------------------------------------- */

   $('.mu-video-play-btn').on('click', function(event) {
	   
        event.preventDefault();
        
        $('.mu-video-iframe-area').addClass('mu-video-iframe-display');
       
    });
   
    // when click the close btn

    // disappear iframe window
    
    $('.mu-video-close-btn').on('click', function(event) {
	    
	    event.preventDefault();
	    
		$('.mu-video-iframe-area').removeClass('mu-video-iframe-display');
		
    });

    // stop iframe if it is play while close the iframe window

    $('.mu-video-close-btn').click(function(){

        $('.mu-video-iframe').attr('src', $('.mu-video-iframe').attr('src'));

    });

    // when click overlay area

     $('.mu-video-iframe-area').on('click', function(event) {
	    
	    event.preventDefault();
	    
		$('.mu-video-iframe-area').removeClass('mu-video-iframe-display');
		
    });

	$('.mu-video-iframe-area, .mu-video-iframe').on('click', function(e){
	    e.stopPropagation();
	});


   	/* ----------------------------------------------------------- */
	/*  3. TESTIMONIALS (SLICK SLIDER)
	/* ----------------------------------------------------------- */

		$('.mu-testimonial-slide').not('.slick-initialized').slick({
			arrows: true,
			dots: false,
			infinite: true,
			speed: 500,
			autoplay: true,
			cssEase: 'linear'
		});

	/* ----------------------------------------------------------- */
  	/*  4. SCROLL TOP BUTTON
  	/* ----------------------------------------------------------- */

	  //Check to see if the window is top if not then display button

	    jQuery(window).scroll(function(){
	      if (jQuery(this).scrollTop() > 300) {
	        jQuery('.scrollToTop').fadeIn();
	      } else {
	        jQuery('.scrollToTop').fadeOut();
	      }
	    });
	     
	    //Click event to scroll to top

	    jQuery('.scrollToTop').click(function(){
	      jQuery('html, body').animate({scrollTop : 0},800);
	      return false;
	    });
	 
		
	/* ----------------------------------------------------------- */
	/*  5. CLIENTS SLIDEER ( SLICK SLIDER )
	/* ----------------------------------------------------------- */

		$('.mu-clients-slider').not('.slick-initialized').slick({
		  slidesToShow: 5,
		  arrows: false,
		  autoplay: true,
		  responsive: [
		    {
		      breakpoint: 768,
		      settings: {
		        arrows: false,
		        slidesToShow: 3
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        arrows: false,
		        slidesToShow: 2
		      }
		    }
		  ]
		});

	
	/* ----------------------------------------------------------- */
	/*  6. PORTFOLIO GALLERY
	/* ----------------------------------------------------------- */ 
	
		if($('body .filtr-container').length > 0){
			$('.filtr-container').filterizr();

			//Simple filter controls

			$('.mu-simplefilter li').click(function() {
			$('.mu-simplefilter li').removeClass('active');
				$(this).addClass('active');
			});
		}


	/* ----------------------------------------------------------- */
	/*  7. PORTFOLIO POPUP VIEW ( IMAGE LIGHTBOX )
	/* ----------------------------------------------------------- */ 

	$('.mu-imglink').magnificPopup({
	  type: 'image',
	  mainClass: 'mfp-fade',
	  gallery:{
	    enabled:true
	  }
	});

	// Upload trick

	$('#resume').change(function(e){
		var fileName = e.target.files[0].name;
		$('#resumeT').val("Selected file: "+fileName);
	});
}

function switchNavMenu(value){
	$('.nav-item').removeClass('active');
	$('.'+value).addClass('active');
}

function uploadFileTrick(){
	$("#resume").click();
}



